import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { setJwt, setSsoSession } from "../lib/api";

export function AuthComplete() {
  const [params] = useSearchParams();
  const nav = useNavigate();

  useEffect(() => {
    const jwt = params.get("jwt");
    if (jwt) {
      setJwt(jwt);
      // Establish the SSO cookie immediately so connecting Claude later is a
      // silent auto-approve (no second magic-link email).
      void setSsoSession();
      nav("/projects", { replace: true });
    }
  }, [params, nav]);

  return (
    <div className="min-h-screen grid place-items-center px-6">
      <div className="text-fg-1 text-sm">Signing you in…</div>
    </div>
  );
}
